import type { EnvironmentName } from './environment.model';

export const environment = {
  name: 'dev' as EnvironmentName,
  version: '2.3.0',
  comingSoon: false as boolean,
  underConstruction: false as boolean,
  fastRemoteConfigFetch: false as boolean,
  firebaseConfig: {
    apiKey: 'AIzaSyB3Ix-7Az5GQpoSA0V3zR8RHglZHJTuOgE',
    authDomain: 'karting-stats---dev.firebaseapp.com',
    projectId: 'karting-stats---dev',
    storageBucket: 'karting-stats---dev.firebasestorage.app',
    messagingSenderId: '351160693413',
    appId: '1:351160693413:web:d7fc9f08223d64778c934c',
  },
  collections: {
    users: 'users',
    usernames: 'usernames',
    follows: 'follows',
    posts: 'posts',
    savedComparisons: 'saved_comparisons',
    vouchers: 'vouchers',
  },
} as const;
